import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { StarBall } from '@sorare/core/src/atoms/icons/StarBall';
import {
  Horizontal,
  SBHorizontal,
  Vertical,
} from '@sorare/core/src/atoms/layout/flex';
import { BrandS, HeadlineL, LabelM } from '@sorare/core/src/atoms/typography';
import { FOOTBALL_PLAY_PRO_ONBOARDING_CHOOSE_COMPETITION } from '@sorare/core/src/constants/__generated__/routes';
import { useIsTabletAndAbove } from '@sorare/core/src/hooks/device/useIsTabletAndAbove';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

import { MarketGuidanceLayout } from 'components/onboarding/MarketGuidanceLayout';

import bg from './assets/bg.png';
import box from './assets/box.png';
import cash from './assets/cash.png';
import jersey from './assets/jersey.png';
import stadiumWithLineup from './assets/stadium.png';
import ticket from './assets/ticket.png';

const LayoutWrapper = styled(Vertical)`
  & > * {
    flex: 1;
  }
  @media ${tabletAndAbove} {
    flex-direction: row;
    align-items: flex-start;
  }
`;
const GoalExplanation = styled(Vertical).attrs({ gap: 2 })`
  width: 100%;
  border-radius: var(--double-unit);
  padding: var(--double-unit);
  background: no-repeat center / cover url(${bg});

  @media ${tabletAndAbove} {
    width: max-content;
  }
`;

const TutorialPage = () => {
  const isTabletAndAbove = useIsTabletAndAbove();

  return (
    <MarketGuidanceLayout
      cta={
        <Button
          size="medium"
          color="secondary"
          to={FOOTBALL_PLAY_PRO_ONBOARDING_CHOOSE_COMPETITION}
        >
          <FormattedMessage
            id="TutorialPage.cta"
            defaultMessage="Build My Club"
          />
        </Button>
      }
    >
      <Vertical center={isTabletAndAbove} gap={2}>
        <StarBall width={40} height={40} />
        <HeadlineL>
          <FormattedMessage
            id="TutorialPage.explanation"
            defaultMessage="Sorare is a fantasy football game comprised of 5-man lineups."
          />
        </HeadlineL>
        <LayoutWrapper>
          <img src={stadiumWithLineup} alt="" />
          <GoalExplanation>
            <SBHorizontal>
              <BrandS>
                <FormattedMessage
                  id="TutorialPage.yourGoal"
                  defaultMessage="Your Goal"
                />
              </BrandS>
              <button onClick={() => null} type="button">
                <FontAwesomeIcon icon={faInfoCircle} />
              </button>
            </SBHorizontal>
            <LabelM>
              <FormattedMessage
                id="TutorialPage.text1"
                defaultMessage="Field the best lineup each Game Week for your chance to win:"
              />
            </LabelM>
            <Vertical gap={2}>
              <Horizontal>
                <img width={20} height={20} src={cash} alt="" />
                <BrandS>
                  <FormattedMessage
                    id="TutorialPage.cash"
                    defaultMessage="Cash"
                  />
                </BrandS>
              </Horizontal>
              <Horizontal>
                <img width={20} height={20} src={jersey} alt="" />
                <BrandS>
                  <FormattedMessage
                    id="TutorialPage.jersey"
                    defaultMessage="Signed jerseys"
                  />
                </BrandS>
              </Horizontal>
              <Horizontal>
                <img width={20} height={20} src={ticket} alt="" />
                <BrandS>
                  <FormattedMessage
                    id="TutorialPage.ticket"
                    defaultMessage="Match Tickets"
                  />
                </BrandS>
              </Horizontal>
              <Horizontal>
                <img width={20} height={20} src={box} alt="" />
                <BrandS>
                  <FormattedMessage
                    id="TutorialPage.more"
                    defaultMessage="And more!"
                  />
                </BrandS>
              </Horizontal>
            </Vertical>
          </GoalExplanation>
        </LayoutWrapper>
      </Vertical>
    </MarketGuidanceLayout>
  );
};
export default TutorialPage;
